module.exports = __webpack_public_path__ + "static/NorimahYusofPhDMALAYSIA-4c83a6ae106f84fe73a768bbaf341336.jpg";